import { render, staticRenderFns } from "./ProjectMetadata.vue?vue&type=template&id=370e9bb1&"
import script from "./ProjectMetadata.vue?vue&type=script&lang=js&"
export * from "./ProjectMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports